import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';import Meta from 'quasar/src/plugins/Meta.js';import Notify from 'quasar/src/plugins/Notify.js';import setCssVar from 'quasar/src/utils/set-css-var.js';;
import lang from 'quasar/lang/es';

import './ui/styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';

setCssVar('primary', '#0635C9');
setCssVar('secondary', '#9BE8D9');
setCssVar('accent', '#686794');

export default {
  config: {},
  plugins: {
    Dialog,
    Loading,
    Meta,
    Notify
  },
  lang: lang
}